import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './components/HomePage';
import InsuranceForm from './components/InsuranceForm';
import CoverOptions from './components/CoverOptions';
import Testimonials from './components/Testimonial';
import AboutUs from './components/AboutUs';
import AdminLogin from './components/AdminLogin';
// import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import TermsAndConditions from './components/TermsAndConditions'
import ConfirmationPage from './components/ConfirmationPage'
import AdminDashboard from './components/AdminDashboard';
// import AgentForm from './components/AgentForm';
import AgentLogin from './components/AgentLogin';
import AgentDashboard from './components/AgentDashboard';
import AgentSignup from './components/AgentSignup';
import PrivateRoute from "./components/PrivateRoute";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin_dashboard" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }/>
        <Route path="/purchase" element={<InsuranceForm />} />
        <Route path="/pricing" element={<CoverOptions/>} />
        <Route path='/about' element={<AboutUs/>} />
        <Route path='/testimonials' element={<Testimonials/>} />
        <Route path='/terms-and-conditions' element={<TermsAndConditions/>} />
        <Route path='/confirmation' element={<ConfirmationPage/>} />

        <Route path='/agent-signup' element={<AgentSignup/>} />
        <Route path='/agent-login' element={<AgentLogin/>} />

        <Route element={<PrivateRoute/>}>
          <Route path="/agent-dashboard" element={<AgentDashboard/>} />
        </Route>
        
      </Routes>
    </Router>
  );
}

export default App;